import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    activityType: String,
    page: String,
    sponsorId: String,
    placementKey: String,
    ticketOfferId: String
  }

  track(event) {
    if (!this.hasUrlValue || !this.hasActivityTypeValue) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new URLSearchParams()
    if (token) body.set("authenticity_token", token)
    body.set("activity_type", this.activityTypeValue)
    if (this.hasPageValue) body.set("page", this.pageValue)
    if (this.hasSponsorIdValue) body.set("properties[sponsor_id]", this.sponsorIdValue)
    if (this.hasPlacementKeyValue) body.set("properties[placement_key]", this.placementKeyValue)
    if (this.hasTicketOfferIdValue) body.set("properties[ticket_offer_id]", this.ticketOfferIdValue)

    if (navigator.sendBeacon) {
      const payload = new Blob([body.toString()], { type: "application/x-www-form-urlencoded" })
      navigator.sendBeacon(this.urlValue, payload)
      return
    }

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token || "",
        "Accept": "application/json"
      },
      body: body.toString(),
      keepalive: true
    }).catch(() => {})
  }
}
